import { render, staticRenderFns } from "./APISpecifications.vue?vue&type=template&id=592d6734&scoped=true&"
import script from "./APISpecifications.vue?vue&type=script&lang=ts&"
export * from "./APISpecifications.vue?vue&type=script&lang=ts&"
import style0 from "./APISpecifications.vue?vue&type=style&index=0&id=592d6734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d6734",
  null
  
)

export default component.exports